import * as React from "react";
import { useAmplitude } from "react-amplitude-hooks";
import styled from "@emotion/styled";
import { getParameterByName } from "../../function";
interface Props {
  stepInfo: string;
}

const Header: React.FC<Props> = ({ stepInfo }) => {
  const { logEvent } = useAmplitude();
  const platform = getParameterByName("platform", window.location.search);
  const mrtPlatform = platform ? `&platform=${platform}` : "";

  return (
    <HeaderWrap>
      <a
        href={process.env.REACT_APP_BOMAPP_PARTNER_URL + mrtPlatform}
        onClick={() =>
          logEvent("logo_button", {
            source: stepInfo
          })
        }
      >
        <h1>
          <img
            src={`${process.env.REACT_APP_S3_URL}/bomapp_30_b2b2c/images/mrt/logo.svg`}
            alt="마이리얼트립X보맵파트너"
          />
        </h1>
      </a>
      {/* {stepInfo === "introduce" ? (
        <Link
          to="/travel/mrt/subscription"
          onClick={() => logEvent("history_button")}
          className="historyButton"
        >
          가입내역확인
        </Link>
      ) : (
        <Link
          to="/travel/mrt/introduce"
          onClick={() => logEvent("history_main_button")}
          className="historyButton"
        >
          여행보험메인
        </Link>
      )} */}
    </HeaderWrap>
  );
};

const HeaderWrap = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 13px 0;
  padding-left: env(safe-area-inset-left);
  border-bottom: 1px solid ${(props) => props.theme.colors.divider2};
  line-height: 0;

  h1 {
    margin-left: 20px;
  }

  .historyButton {
    margin-top: 1px;
    font-size: ${(props) => props.theme.text.sizeFont};
    text-decoration: underline;
  }
`;

export default Header;
